import React from 'react';
import { motion } from 'framer-motion';
import {
    FaAws, FaGoogle, FaMicrosoft, FaApple, FaReact, FaNodeJs, FaPython, FaDocker
} from 'react-icons/fa';

// Logo Data with Official Brand Colors
const logos = [
    { Icon: FaReact, color: "#61DAFB", name: "React" },
    { Icon: FaNodeJs, color: "#339933", name: "Node.js" },
    { Icon: FaPython, color: "#3776AB", name: "Python" },
    { Icon: FaDocker, color: "#2496ED", name: "Docker" },
    { Icon: FaAws, color: "#FF9900", name: "AWS" },
    { Icon: FaGoogle, color: "#4285F4", name: "Google" },
    { Icon: FaMicrosoft, color: "#F25022", name: "Microsoft" }, // Using Microsoft Red-Orange as primary brand feel or window colors
    { Icon: FaApple, color: "#000000", name: "Apple" }
];

const Clients = () => {
    return (
        <section className="bg-white pt-2 pb-8 border-b border-gray-100 overflow-hidden relative font-sans">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 text-center">
                <p className="text-sm font-bold uppercase tracking-[0.2em] text-slate-500">
                    Trusted by Tech Giants & Startups
                </p>
            </div>

            <div className="relative w-full overflow-hidden">
                {/* Gradient Masks for Fading edges */}
                <div className="absolute top-0 bottom-0 left-0 w-32 z-10 bg-gradient-to-r from-white to-transparent pointer-events-none"></div>
                <div className="absolute top-0 bottom-0 right-0 w-32 z-10 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>

                {/* Marquee Container */}
                <div className="flex w-full overflow-hidden">
                    <motion.div
                        className="flex items-center gap-16 min-w-full"
                        animate={{ x: ["0%", "-100%"] }}
                        transition={{ duration: 30, ease: "linear", repeat: Infinity }}
                    >
                        {/* Tripled List for Smooth Loop */}
                        {[...logos, ...logos, ...logos].map((item, index) => (
                            <div
                                key={index}
                                className="flex-shrink-0 text-5xl md:text-6xl transition-transform duration-300 hover:scale-110 cursor-pointer"
                                style={{ color: item.color }}
                                title={item.name}
                            >
                                <item.Icon />
                            </div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Clients;
